export default "__VITE_ASSET__yfpe8xBA__"